(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore', 'torso/modules/View', 'templates', 'app/launcherApplicationInterface'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var templates = { layoutTemplate: require('./layoutTemplate.hbs') };
    module.exports = factory(require ('underscore'), require('backbone-torso/modules/View'), templates, require('./../launcherApplicationInterface'));
  } else {
    // Browser globals (root is window)
    root.LauncherAppInterface = factory();
  }
}(this, function (_, TorsoView, templates, launcherAppInterface) {
  'use strict';

  /**
   * Perspective for the layout
   *
   * @class LayoutPerspective
   */
  return TorsoView.extend({
    template: templates.layoutTemplate,

    events: {
      'click': '_closeAllDs'
    },

    prepareFields: {
      hasAside: 'asideView',
      hasFooter: 'footerView',
      isAtHospital: function() {
        return launcherAppInterface.isAtHospital();
      }
    },

    injectionSites: {
      content: {
        view: 'contentView',
        options: { shared: true }
      },
      'main-nav': {
        view: 'mainNavView',
        options: { shared: true }
      },
      aside: {
        view: 'asideView',
        options: { shared: true }
      },
      footer: {
        view: 'footerView',
        options: { shared: true }
      }
    },

    /**
     * @method _closeAllDs
     * @private
     *
     * Closes all Drawers, Dropdowns, and Dialogs
     * This is here because we want to trigger it on the
     * entire page, which is larger than the area accessible
     * to the navigation widget.
     */
    _closeAllDs: function() {
      if (_.isFunction(this.getNavView) && this.getNavView().isAttached() && !launcherAppInterface.isAtHospital()) {
        this.getNavView().closeMainNavDrawer();
      } else if (this.mainNavView) {
        this.mainNavView.closeMainNavDrawer();
      }
    },

    /**
     * @method setContentView
     * @param contentView {Torso.View} the view to render in the content section of the template.
     */
    setContentView: function(contentView) {
      this.contentView = contentView;
      this.render();
    },

    /**
     * @method _toggleSidebarClass
     * @param childView {object}
     * @private
     *
     * We listen to the designNav (and mainNavView through it) for changes to the
     * menu's state. We then display or hide it based on the child view where the
     * button actually resides.
     */
    _toggleSidebarClass: function(childView) {
      var isOpen = childView.get('mainNavDrawerOpen');
      this.set('mainNavDrawerOpen', isOpen);
    },

    /**
     * @method initialize
     * @override
     */
    initialize: function() {
      if (this.mainNavView) {
        this.listenTo(this.mainNavView, 'change:mainNavDrawerOpen', this._toggleSidebarClass);
      }
      this.listenTo(this.viewState, 'change:mainNavDrawerOpen', this.render);
    },

    /**
     * @method postrender
     * @override
     */
    postrender: function() {
      if (_.isFunction(this.getNavView) && this.getNavView().isAttached()) {
        var navView = this.getNavView().viewState;
        this.listenTo(navView, 'change:mainNavDrawerOpen', this._toggleSidebarClass);
      }
    }
  });
}));
